import { render, staticRenderFns } from "./item_commondit_type.vue?vue&type=template&id=f1d3760e&scoped=true&"
import script from "./item_commondit_type.vue?vue&type=script&lang=js&"
export * from "./item_commondit_type.vue?vue&type=script&lang=js&"
import style0 from "./item_commondit_type.vue?vue&type=style&index=0&id=f1d3760e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d3760e",
  null
  
)

export default component.exports